import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { fetchBudgetProjet } from '../../api/budgetProjetApi';

const BudgetParProjet = ({ projetId }) => {
  const [budgets, setBudgets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projetId) {
      setError(new Error("projetId est requis"));
      setLoading(false);
      return;
    }
    const loadBudgets = async () => {
      try {
        const data = await fetchBudgetProjet(projetId);
        setBudgets(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    loadBudgets();
  }, [projetId]);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Erreur : {error.message}</div>;

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'poste_budgetaire', headerName: 'Poste Budgétaire', width: 200 },
    { field: 'montant_prevu', headerName: 'Montant Prévu', width: 150 },
    { field: 'montant_reel', headerName: 'Montant Réel', width: 150 },
  ];

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={budgets}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
    </Box>
  );
};

export default BudgetParProjet;
